import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function EFDeleteIcon() {
  const isDark = useAppSelector(isDarkTheme)
  const fill = isDark ? 'var(--color-error)' : '#FA3737'
  return (
    <svg
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 5.75H14C14 4.64543 13.1046 3.75 12 3.75C10.8954 3.75 10 4.64543 10 5.75ZM8.5 5.75C8.5 3.817 10.067 2.25 12 2.25C13.933 2.25 15.5 3.817 15.5 5.75H21.25C21.6642 5.75 22 6.08579 22 6.5C22 6.91421 21.6642 7.25 21.25 7.25H19.9309L18.7589 19.3612C18.5729 21.2834 16.9575 22.75 15.0263 22.75H8.97369C7.04254 22.75 5.42715 21.2834 5.24113 19.3612L4.06908 7.25H2.75C2.33579 7.25 2 6.91421 2 6.5C2 6.08579 2.33579 5.75 2.75 5.75H8.5ZM10.5 10.5C10.5 10.0858 10.1642 9.75 9.75 9.75C9.33579 9.75 9 10.0858 9 10.5V18C9 18.4142 9.33579 18.75 9.75 18.75C10.1642 18.75 10.5 18.4142 10.5 18V10.5ZM14.25 9.75C14.6642 9.75 15 10.0858 15 10.5V18C15 18.4142 14.6642 18.75 14.25 18.75C13.8358 18.75 13.5 18.4142 13.5 18V10.5C13.5 10.0858 13.8358 9.75 14.25 9.75ZM6.73416 19.2167C6.84577 20.37 7.815 21.25 8.97369 21.25H15.0263C16.185 21.25 17.1542 20.37 17.2658 19.2167L18.4239 7.25H5.57608L6.73416 19.2167Z'
        fill={fill}
      />
    </svg>
  )
}
